import React, { useEffect, useState } from 'react';

import { SearchInput } from 'src/component/ds/ui/searchInput';
import { useTranslation } from 'src/i18n';

const DEBOUNCE_MS = 300;

export interface DeviceListSearchProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/* Applies the typed term once typing is paused; clearing applies at once. */
export default function DeviceListSearch ({ value, onChange, className }: DeviceListSearchProps) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    setDraft((current) => (current.trim() === value ? current : value));
  }, [value]);

  useEffect(() => {
    if (draft.trim() === value) {
      return undefined;
    }
    const timer = setTimeout(() => onChange(draft), DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [draft]);

  const onValueChange = (next: string) => {
    setDraft(next);
    if (!next) {
      onChange('');
    }
  };

  return (
    <SearchInput
      value={draft}
      onValueChange={onValueChange}
      placeholder={t('deviceList.search.placeholder')}
      aria-label={t('deviceList.search.label')}
      clearLabel={t('deviceList.search.clear')}
      className={className}
    />
  );
}
